import {
  AbstractControl,
  AsyncValidator,
  AsyncValidatorFn,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { getRemoteConfigState } from '../../store';
import { RemoteConfigState } from '../../store/remote-config/remote-config.reducer';

export class RequiredIfRemoteConfigEnabled implements AsyncValidator {
  private constructor(private store: Store, private validationKey: keyof RemoteConfigState) {}

  static forKey(store: Store, key: keyof RemoteConfigState): AsyncValidatorFn {
    const instance = new RequiredIfRemoteConfigEnabled(store, key);
    return instance.validate.bind(instance);
  }

  validate(
    ctrl: AbstractControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this.store.pipe(
      select(getRemoteConfigState),
      take(1),
      map((state) => !!state[this.validationKey]),
      map((configValue) => {
        return !!configValue ? Validators.required(ctrl) : null;
      })
    );
  }
}
